import { LoadingSpinner } from 'eezy-components'
import FullWidthLayoutWrapper from 'layouts/full-width/FullWidthLayoutWrapper'
import React, { useEffect } from 'react'
import { AuthStore } from 'stores'
import { clearAuthToken } from 'util/auth/cookies'
import { useInstance } from 'util/di'

import { useGetApiV1Session } from 'api'

type Props = {
  apiToken: string
}

const SessionLoader: React.FC<Props> = ({ apiToken }) => {
  const { setSession, setTokenRejected } = useInstance<AuthStore>('AuthStore')

  const { data: session, error } = useGetApiV1Session({
    requestOptions: { headers: { Authorization: 'Bearer ' + apiToken } },
  })

  useEffect(() => {
    if (session) {
      setSession(session)
    } else if (error) {
      // Hand back to App so it can try the remember cookie. The flag stops a loop back
      // here if the cookie could not be cleared.
      clearAuthToken()
      setTokenRejected(true)
    }
  }, [session, error, setSession, setTokenRejected])

  return (
    <FullWidthLayoutWrapper>
      <LoadingSpinner />
    </FullWidthLayoutWrapper>
  )
}

export default SessionLoader
